import React from 'react'

function ProfileWidgetAnniste() {
  return (
    <div className="card shadow-sm h-100">Annisite
        <div className="card-body">
            
        </div>
    </div>
  )
}

export default ProfileWidgetAnniste